module.exports = __webpack_public_path__ + "img/turbo_off.31b698c9.png";